(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcTestResultListController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        $scope.govProcess = $scope.boxContext.GovernanceProcess;
        $scope.control = $scope.boxContext.Control;
        $scope.controlTest = $scope.boxContext.ControlTest;
        $scope.controlTestResults = $scope.boxModel;
        $scope.loadingStatus = {
            isLoading: false
        };

        initTestResults();

        // Can Be Tested?
        $scope.isTestable = canBeTested();
        $scope.testResultsDeWatcher = function() {};

        function canBeTested() {
            if ($scope.readOnly) return false;
            if (_.isUndefined($scope.control)) return;
            if (_.isUndefined($scope.controlTestResults)) return;

            var testable = true;

            if ($scope.controlTestResults.ActualTestResult && $scope.controlTestResults.ActualTestResult.IsClosed) {
                testable = $scope.controlTestResults.ActualTestResult.IsClosed === false;
            } else if ($scope.controlTest && $scope.controlTest.IsClosed) {
                testable = $scope.controlTest.IsClosed === false;
            }

            if ($scope.control.ControlAssessment) {
                testable = $scope.control.ControlAssessment.IsTestable;
            }

            if ($scope.control.IsClosed) {
                testable = false;
            }

            return testable;
        }

        // Init Test Results
        function initTestResults() {
            if (_.isUndefined($scope.controlTestResults.ActualTestResult) && $scope.govProcess && $scope.govProcess.GovernanceProcessID) {
                $scope.controlTestResults.ActualTestResult = {
                    ControlTestID: $scope.controlTest.ControlTestID,
                    GovernanceProcessID: $scope.govProcess.GovernanceProcessID,
                    GovernanceProcess: $scope.govProcess,
                    PerformedByID: $scope.authenticatedUser.ItemPersonID
                };
            }
        }

    }
})();